import React from "react";
import LegalPage from "../../components/LegalPage";
import { getViewPrivacyPolicyList } from "../../services/TermsConditionService";
import useSeo from "../../utils/useSeo";

const PrivacyPolicy = () => {
  useSeo({
    title: "Política de Privacidade",
    description:
      "Saiba como a TP Software recolhe, trata e protege os seus dados pessoais. Conformidade total com o RGPD e a legislação portuguesa de protecção de dados.",
    keywords: "política de privacidade, RGPD, protecção de dados, dados pessoais, TP Software, privacidade",
    path: "/privacy-policy",
  });

  return (
    <LegalPage
      eyebrow="Proteção de Dados"
      title="Política de Privacidade"
      subtitle="Como recolhemos, tratamos e protegemos os dados pessoais dos utilizadores da TP Software, em conformidade com o RGPD."
      fetcher={getViewPrivacyPolicyList}
      emptyMessage="A Política de Privacidade será publicada em breve."
    />
  );
};

export default PrivacyPolicy;
